export const WAREHOUSES = {
    WAREHOUSES_CONTAINER: "warehouses-container",
    WAREHOUSE_ENTRY: "warehouse-entry",
    CREATE_WAREHOUSE: "create-warehouse",
    NAME: "name",
    CODE: "code",
    POSTAL_CODE: "postal-code",
    COUNTRY: "country",
    OVERSELLING_TOGGLE: "overselling-toggle",
    SAVE: "save",
    DELETE: "delete",
    RETURN_TO_ADMIN: "return-to-admin",
    DIALOG_DELETE: "dialog-delete",
    DIALOG_NAME_WAREHOUSE: "dialog-name-warehouse",
};
